import { types, flow } from "mobx-state-tree";
import { toJS } from "mobx";
import StatusCode from "../../utils/errorsCode";
import NotiService from "../../service/NotificationRequestServcice";
import NotificationRequestService from "../../service/NotificationRequestServcice";
import moment from "moment";

const owner = types.model({
    "_id": types.string,
    username: types.string
})

const approved = types.model({
    "_id": types.string,
    username: types.string
})

const reportData = types.model({
    total: types.optional(types.integer, 0),
    sent: types.optional(types.integer, 0),
    open: types.optional(types.integer, 0),
    error: types.optional(types.integer, 0)
})

const requestStatus = types.model({
    appId: types.maybeNull(types.integer),
    deviceName: types.maybeNull(types.string),
    email: types.maybeNull(types.string),
    opened_at: types.maybeNull(types.string),
    created_at: types.maybeNull(types.string),
    session: types.maybeNull(types.integer),
    status: types.maybeNull(types.string)
})

const notificationRequests = types.model({
    id: types.integer,
    message_id: types.maybeNull(types.integer),
    search_query_id: types.maybeNull(types.string),
    push_request_id: types.maybeNull(types.integer),
    approved_at: types.maybeNull(types.string),
    status: types.enumeration(["pending", "success", "cancel", "error"], "pending"),
    body: types.maybeNull(types.string),
    title: types.maybeNull(types.string),
    owner: types.maybeNull(owner),
    approved: types.maybeNull(approved),
    schedule_time: types.maybeNull(types.string),
    start_push_date: types.maybeNull(types.string),
    created_at: types.optional(types.string, new Date().toString()),
    updated_at: types.maybeNull(types.string),
})

const exportDetail = types.model({
    email: types.maybeNull(types.string),
    opened_at: types.maybeNull(types.string)
})

export const NotificationRequests = types.model({
    state: types.optional(types.enumeration(["running", "done", "init", "error"]), "init"),
    notificationRequests: types.optional(types.array(notificationRequests), []),
    getNotificationLoading: types.optional(types.boolean, false),
    dataReport: types.optional(reportData, {}),
    reportTitle: types.maybeNull(types.string),
    dataByStatusNotification: types.optional(types.array(requestStatus), []),
    exportData: types.optional(types.array(exportDetail), [])
})
    .actions(self => ({
        getNotiRequests: flow(function* (params = {}) {
            self.getNotificationLoading = true;
            self.state = "running";
            try {
                let res = yield NotiService.get(params)
                if (res.status) {
                    self.notificationRequests = res.data
                    self.state = "done";
                }
            } catch ({ data }) {
                if (!data.status) {
                    alert(StatusCode[data.error])
                }
            }
            self.getNotificationLoading = false
        }),
        acceptedRequest: flow(function* (data, getQuery) {
            try {
                const res = yield NotificationRequestService.accepted(data)
                if (res.status) {
                    setTimeout(() => {
                        self.getNotiRequests(getQuery)
                    }, 200);
                }
            } catch ({ data }) {
                if (!data.status) {
                    alert(StatusCode[data.error])
                }
            }
        }),
        cancelRequest: flow(function* (data, getQuery) {
            try {
                const res = yield NotificationRequestService.cancel(data)
                if (res.status) {
                    self.getNotiRequests(getQuery)
                }
            } catch ({ data }) {
                if (!data.status) {
                    alert(StatusCode[data.error])
                }
            }
        }),
        deleteRequest: flow(function* (params = {}, getQuery) {
            try {
                const res = yield NotificationRequestService.del(params);
                if (res.status) {
                    self.getNotiRequests(getQuery)
                }
            } catch ({ data }) {
                if (!data.status) {
                    alert(StatusCode[data.error])
                }
            }
        }),
        getDataReport: flow(function* (params = {}) {
            try {
                const res = yield NotificationRequestService.report(params)
                if (res.status) {
                    self.reportTitle = res.data.title
                    
                    delete res.data.title
                    self.dataReport = res.data
                }
            } catch ({data}) {
                if (!data.status) {
                    alert(StatusCode[data.error])
                }
            }
        }),
        getDataExport: flow(function* (params = {}){
            self.state = "running"
            try {
                const res = yield NotificationRequestService.notiExport(params)
                if (res.status) {
                    let csvContent = "data:text/csv;charset=utf-8,";
                    let exportData = [
                        ["Email", "Push Date"]
                    ]
                    for (let item of res.data) {
                        let dataItem = []
                        dataItem.push(!!item.email ? item.email: "null")
                        let created_at = item.created_at ? moment(item.created_at).format("DD/MM/YYYY HH:mm") : "null"
                        dataItem.push(created_at)
                        exportData.push(dataItem)
                    }

                    csvContent += exportData.map(e => e.join(",")).join("\n")
                    const encodeUri = encodeURI(csvContent)
                    const link = document.createElement("a")
                    link.setAttribute("href", encodeUri);
                    link.setAttribute("download", "email_list.csv");
                    document.body.appendChild(link)

                    link.click();
                    self.state = "done";
                }
            } catch ({data}) {
                alert(StatusCode[data.error])
            }
        }),
        getDataByStatus: flow(function* (params = {}) {
            try {
                const res = yield NotificationRequestService.requestByStatus(params)
                if (res.status) {
                    self.dataByStatusNotification = res.data
                }
            } catch ({data}) {
                if (!data.status) {
                    alert(StatusCode[data.error])
                }
            }
        })
    }))
    .views(self => ({
        get getNotiLoading() {
            return toJS(self.getNotificationLoading);
        },
        get dataNotificationRequests() {
            let result = []

            for (let item of toJS(self.notificationRequests)) {
                result.push({ query: !!item.search_query_id ? item.search_query_id : "Email list", ...item })
            }
            return result
        },
        get dataPendingNotificationRequests() {
            let result = []

            for (let item of toJS(self.notificationRequests)) {
                if (moment().diff(moment(item.schedule_time), "seconds") <= 0) {
                    result.push({ query: !!item.search_query_id ? item.search_query_id : "Email list", ...item })
                }
            }
            return result
        },
        get dataReportNotification() {
            let data = []
            let keys = Object.keys(toJS(self.dataReport))
            for (let key of keys) {
                let dataItem = {}
                if (key === "sent" || key === "error") {
                    dataItem.name = key;
                    dataItem.value = toJS(self.dataReport)[key]
                    data.push(dataItem)
                } 
            }
            return data
        }
    }))